import { render, staticRenderFns } from "./NavBarComp.vue?vue&type=template&id=480deda4&scoped=true"
import script from "./NavBarComp.vue?vue&type=script&lang=js"
export * from "./NavBarComp.vue?vue&type=script&lang=js"
import style0 from "./NavBarComp.vue?vue&type=style&index=0&id=480deda4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480deda4",
  null
  
)

export default component.exports